import type { VideoRenderer } from "@msuite/ui/libs/tiptap";
import { useCallback } from "react";
import { WikiVideoBlock } from "@/components/wiki";

/**
 * The app-side half of the editor's `videoBlock` node: resolves a video id to the embedded
 * player. Stable across renders, because the editor rebuilds its extension list whenever the
 * renderer's identity changes.
 */
export function useVideoRenderer(): VideoRenderer {
	return useCallback(
		(attrs) => (
			<WikiVideoBlock
				videoId={attrs.videoId}
				isEditable={attrs.isEditable}
			/>
		),
		[],
	);
}
